// extracted by css-extract-rspack-plugin
export default {"container":"Metadata-module__container__iYXy3Ih","heading":"Metadata-module__heading__XcDEQzf"};